/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S3_P1Inputs */

const en_guide_json_rest_api_s3_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Well-designed APIs follow consistent JSON response patterns. Here are the most common structures you'll encounter:`)
};

const ko_guide_json_rest_api_s3_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잘 설계된 API는 일관된 JSON 응답 패턴을 따릅니다. 가장 자주 접하게 되는 구조는 다음과 같습니다:`)
};

const ja_guide_json_rest_api_s3_p1 = /** @type {(inputs: Guide_Json_Rest_Api_S3_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`よく設計されたAPIは一貫したJSONレスポンスパターンに従います。以下は最も一般的な構造です：`)
};

/**
* | output |
* | --- |
* | "Well-designed APIs follow consistent JSON response patterns. Here are the most common structures you'll encounter:" |
*
* @param {Guide_Json_Rest_Api_S3_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s3_p1 = /** @type {((inputs?: Guide_Json_Rest_Api_S3_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S3_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s3_p1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s3_p1(inputs)
	return ja_guide_json_rest_api_s3_p1(inputs)
});